<template>
  <div>
    <el-alert
      title="提醒："
      type="warning"
      show-icon
      :closable="false"
      class="mb-4"
    >
      <p>Apple Pay、Google Pay 於 Webview 環境中不支援，客人結帳時將不會顯示此選項。</p>
    </el-alert>
    <BaseElFormItem label="MerchantId" prop="newebpay.newebpayMerchantId">
      <BaseElInput v-model="syncForm.newebpayMerchantId" placeholder="請輸入 MerchantId" />
    </BaseElFormItem>
    <BaseElFormItem label="HashKey" prop="newebpay.newebpayHashKey">
      <BaseElInput v-model="syncForm.newebpayHashKey" placeholder="請輸入 HashKey" />
    </BaseElFormItem>
    <BaseElFormItem label="HashIV" prop="newebpay.newebpayHashIV">
      <BaseElInput v-model="syncForm.newebpayHashIV" placeholder="請輸入 HashIV" />
    </BaseElFormItem>
  </div>
</template>

<script>
export default {
  name: 'NewePayForm',
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    syncForm: {
      get () {
        return this.formData
      },
      set (v) {
        return this.$emit('update', v)
      },
    },
  },
}
</script>

<style lang="postcss" scoped></style>
